import React, {useEffect, useState} from "react";
import {useTheme} from "@mui/material/styles";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {useNavigate} from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDInput from "components/MDInput";
import {
  Alert,
  AppBar,
  Card,
  FormControlLabel,
  Snackbar,
  InputLabel,
  Typography,
  MenuItem,
  Select,
  FormControl
} from "@mui/material";
import MDButton from "components/MDButton";
import {PATCH} from "APIclient";
import {useLocation} from "react-router-dom";
import {DataGrid} from "@mui/x-data-grid";
import {column} from "stylis";
import {useMaterialUIController} from "context";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {DemoContainer} from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {POST} from "APIclient";
import {GET} from "APIclient";
import {BASE_URL} from "APIclient";
import axios from "axios";
import properties from "constants/ApplicationConstants";
import {formatDesignation} from "constants/ApplicationConstants";
import {formatDate} from "constants/ApplicationConstants";

function SalaryCertificate() {
  const [controller] = useMaterialUIController();
  const {darkMode} = controller;
  const location = useLocation();
  const [usersState, setUsersState] = useState(location.state);
  const theme = useTheme();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [isPrint, setIsPrint] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [snakColor, setSnakColor] = useState("");
  const [snakMessage, setSnakMessage] = useState("");
  const viewUrl = `admin/get-salaries/${usersState}`;
  const [details, setDetails] = useState([]);
  const [hrManager, setHrManager] = useState([]);
  const [formData, setFormData] = useState({
    issuedBy: ""
  });

  React.useEffect(() => {
    const view = async () => {
      try {
        const response = await GET(viewUrl);
        const view = response?.data?.data;
        const formattedView = {
          ...view,
          designation: formatDesignation(view?.designation)
        };
        setDetails(formattedView);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    view();
  }, [viewUrl]);
  const handleClose = () => {
    setOpen(false);
  };
  const handlePrint = async () => {
    try {
      const url = `${BASE_URL}/admin/employee/downloadCertificate?type=salary_letter&search=${usersState}`;
      const response = await axios.get(url, {
        headers: {
          Accept: "application/pdf",
          Authorization: `Bearer ${window.sessionStorage.getItem("jwtToken")}`
        },
        responseType: "blob",
        withCredentials: true
      });

      if (response.status !== 200) {
        throw new Error("Failed to fetch the PDF");
      }

      const fileBlob = new Blob([response.data], {type: "application/pdf"});
      const fileUrl = URL.createObjectURL(fileBlob);
      const newWindow = window.open(fileUrl, "_blank");

      if (!newWindow) {
        alert("Please allow pop-ups to view the offer letter.");
      }
    } catch (error) {
      console.error("Error fetching offer letter:", error);
      alert("Error generating the offer letter. Please try again.");
    }
  };
  const handleCloseSnackbar = () => setSnackbar(null);

  const handleChange = event => {
    const {name, value} = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    // Prepare the data to be sent to the server
    const dt = {
      issuedBy: parseInt(formData.issuedBy)
    };

    const url = `admin/employee/salary-certificate/${usersState}`;

    try {
      const response = await POST(url, dt);
      if (response?.data?.statusCode === 200) {
        // Successfully updated
        setSnakColor("success");
        setSnakMessage("Permissions updated successfully");
        setOpen(true);
        setIsPrint(true);
        // Optionally navigate to another page after successful update
        // navigate('/some/other/page');
      } else {
        setSnakColor("error");
        setSnakMessage("Failed to update permissions");
        setOpen(true);
      }
    } catch (error) {
      console.error("Error updating permissions:", error);
      setSnakColor("error");
      setSnakMessage("Error updating permissions");
      setOpen(true);
    }
  };

  React.useEffect(() => {
    const getUrl = `admin/hr-managers`;
    const getHrManager = async () => {
      try {
        const response = await GET(getUrl);
        const data = response?.data?.data;
        setHrManager(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    getHrManager();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox container>
        <AppBar position="static">
          <Card>
            <MDBox
              pt={2}
              mb={0}
              pb={4}
              px={4}
              sx={{borderRadius: "5px", border: "1px solid #D3D3D3"}}
            >
              {/* <Typography variant="h6" color="textPrimary"> Appointment Letter</Typography> */}

              <MDBox
                component="li"
                display="flex"
                justifyContent="space-between"
                alignItems="flex-start"
                bgColor={darkMode ? "transparent" : "grey-100"}
                borderRadius="lg"
                p={2}
                mt={1}
              >
                <MDBox width="100%" display="flex" flexDirection="column">
                  <MDTypography
                    variant="h6"
                    fontWeight="medium"
                    pb={2}
                    sx={{fontFamily: properties.fontFamily}}
                  >
                    Employee Details
                  </MDTypography>
                  <MDBox
                    display="grid"
                    gridTemplateColumns={{xs: "1fr", sm: "repeat(3, 1fr)"}}
                    gap={2}
                    mb={2}
                  >
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Employee ID:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.empId : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Joining Date:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? formatDate(details.joinDate) : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Designation:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.designation : "-"}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  <MDBox
                    display="grid"
                    gridTemplateColumns={{xs: "1fr", sm: "repeat(3, 1fr)"}}
                    gap={2}
                    mb={2}
                  >
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        First Name:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.firstName : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Middle Name:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.middleName : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Last Name:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.lastName : "-"}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  <MDBox
                    display="grid"
                    gridTemplateColumns={{xs: "1fr", sm: "repeat(3, 1fr)"}}
                    gap={2}
                    mb={2}
                  >
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120INavigation"}}
                      >
                        Personal Email ID:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.emailAddress : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Official Email ID:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.officialEmailAddress : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Mobile:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.mobileNo : "-"}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  <MDBox
                    display="grid"
                    gridTemplateColumns={{xs: "1fr", sm: "repeat(3, 1fr)"}}
                    gap={2}
                    mb={2}
                  >
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Current CTC:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.salary : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Applicable From:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? formatDate(details.fromDate) : "-"}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDBox>
              {/* </MDBox> */}
              {/* <DataGrid rows={rows} columns={columns} pagination={false} hideFooter={rows.length <= 20} hideFooterPagination={true} /> */}
              <MDBox pt={2} mb={0} pb={4} px={4}>
                <InputLabel sx={{fontWeight: "bold", paddingBottom: "20px"}}>
                  Salary Certificate Details
                </InputLabel>

                <MDBox pt={2}>
                  <FormControl variant="standard" sx={{m: 1, width: "30ch"}}>
                    <InputLabel id="issuedBy" sx={{fontWeight: "bold"}}>
                      Issued By <span style={{color: properties.colors.Red}}>*</span>
                    </InputLabel>
                    <Select
                      pb={4}
                      labelId="issuedBy"
                      id="issuedBy"
                      value={parseInt(formData?.issuedBy)}
                      name="issuedBy"
                      onChange={e => handleChange(e)}
                      label="issued By"
                    >
                      <MenuItem value="">
                        <em>Select </em>
                      </MenuItem>
                      {hrManager?.map(manager => (
                        <MenuItem key={manager.empId} value={manager.empId}>
                          {`${manager.firstName} ${manager.lastName}`}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </MDBox>
              </MDBox>

              <MDBox mt={3} mb={2} sx={{display: "flex", justifyContent: "flex-end"}}>
                <MDBox sx={{display: "flex", gap: 1}}>
                  <MDButton
                    variant="gradient"
                    color="warning"
                    sx={{marginRight: "10px", width: "20ch"}}
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </MDButton>
                  <MDButton
                    variant="gradient"
                    color="info"
                    sx={{
                      marginRight: "10px",
                      width: "20ch",
                      background: properties.colors.bgcolorbluethem,
                      display: isPrint ? "none" : ""
                    }}
                    onClick={() => handleSubmit()}
                    disabled={!formData.issuedBy}
                  >
                    Save
                  </MDButton>

                  <MDButton
                    variant="gradient"
                    color="info"
                    sx={{width: "20ch", display: isPrint ? "" : "none"}}
                    onClick={() => handlePrint()}
                  >
                    Print
                  </MDButton>
                </MDBox>
              </MDBox>

              <Snackbar
                open={open}
                anchorOrigin={{vertical: "top", horizontal: "right"}}
                autoHideDuration={1200}
                onClose={handleClose}
              >
                <Alert
                  // autoHideDuration={1200}
                  onClose={handleClose}
                  color="white"
                  severity={snakColor === "success" ? "success" : "error"}
                  variant="filled"
                  sx={{width: "100%"}}
                >
                  {snakMessage}
                </Alert>
              </Snackbar>
            </MDBox>
          </Card>
        </AppBar>
      </MDBox>
    </DashboardLayout>
  );
}

export default SalaryCertificate;
